import React from 'react';

const AngelPricingSection = () => (
    <section className="lp-pricing-sec">
        <h2 className="lp-h2" data-lp-reveal style={{ textAlign: 'center', margin: '0 auto 44px', maxWidth: 680 }}>Simple, transparent pricing.</h2>
        <div className="lp-pricing-grid">
            <div className="lp-price" data-lp-reveal>
                <div className="lbl">Angel network</div>
                <div className="amt">Free</div>
                <p>Full platform access: applicant triage, readiness dashboard, certification visibility, warm rejection flow. No fees, no setup costs, no commitment.</p>
            </div>
            <div className="lp-price lp-price--pro" data-lp-reveal data-lp-delay="100">
                <div className="lbl" style={{ color: "#fff" }}>Applicant companies</div>
                <div className="amt"><span className="per">From</span> £100<span className="per"> / year</span></div>
                <p>You get them the pitch. We get them the money, and their next round follow on funding.</p>
            </div>
        </div>
        <p className="lp-price-note" data-lp-reveal>Networks may subsidise applicant costs. Cohort and bulk pricing available.</p>
    </section>
);

export default AngelPricingSection;
